import { usePrevioRealtime, type Channel } from '@previo/realtime'

let propertyChannel: Channel | null = null

export const initPropertyRealtime = (channelName: string): Channel => {
  if (propertyChannel?.name === channelName) {
    return propertyChannel
  }

  propertyChannel?.unsubscribe()
  propertyChannel = usePrevioRealtime().subscribe(channelName)

  return propertyChannel
}

export const usePropertyRealtime = (): Channel => {
  if (!propertyChannel) {
    throw new Error('Property realtime is not initialized. Call "initPropertyRealtime()" first.')
  }

  return propertyChannel
}
